import { useTranslation } from "react-i18next";
import { Box, Typography } from "../../shared/ui";
import { Navigation } from "../Navigation";
import styles from "./GameLimits.module.scss";

export function GameLimits() {
  const { t } = useTranslation();
  return (
    <>
      <Navigation title={t("game_limits.title").toUpperCase()} />
      <div className={styles.content}>
        <div className={styles.limitRow}>
          <Typography
            variant="body1"
            color="header-small"
            className={styles.label}
          >
            {t("game_limits.minimum_bet_usd")}
          </Typography>
          <div className={styles.dottedLine}></div>
          <Box bg="green" radius="lg" p="sm" className={styles.valueBox}>
            <Typography
              variant="body1"
              color="primary"
              className={styles.value}
            >
              0.10
            </Typography>
          </Box>
        </div>

        <div className={styles.limitRow}>
          <Typography
            variant="body1"
            color="header-small"
            className={styles.label}
          >
            {t("game_limits.maximum_bet_usd")}
          </Typography>
          <div className={styles.dottedLine}></div>
          <Box bg="green" radius="lg" p="sm" className={styles.valueBox}>
            <Typography
              variant="body1"
              color="primary"
              className={styles.value}
            >
              100.00
            </Typography>
          </Box>
        </div>

        <div className={styles.limitRow}>
          <Typography
            variant="body1"
            color="header-small"
            className={styles.label}
          >
            {t("game_limits.maximum_win_for_one_bet_usd")}
          </Typography>
          <div className={styles.dottedLine}></div>
          <Box bg="green" radius="lg" p="sm" className={styles.valueBox}>
            <Typography variant="body1" className={styles.value}>
              10 000.00
            </Typography>
          </Box>
        </div>
      </div>
    </>
  );
}
